/// <reference path="systemlog/templates/systemlog.html" />
(function () {
    'use strict';


    angular.module('app')

    .config(function ($stateProvider, $urlRouterProvider) {

        $urlRouterProvider.otherwise("home");

        $stateProvider
            .state('layout', {
                url: '/',
                controller: 'layout',
                controllerAs: 'layoutVm',
                templateUrl: 'app/layout/templates/layout.html',
                params: {
                    force: false,
                },
                resolve: {
                    auth: function (loginService) {
                        return loginService.isLoggedIn();
                    }
                }
            })
            .state('layout.test', {
                url: 'test',
                templateUrl: 'app/testpage/templates/testpage.html',
                params: {
                    force: false,
                }
            })
            .state('layout.home', {
                url: 'home',
                controller: 'landing',
                controllerAs: 'vm',
                templateUrl: 'app/landing/templates/landing.html',
                params: {
                    force: false,
                }
            })
            .state('login', {
                url: '/login',
                controller: 'login',
                controllerAs: 'vm',
                templateUrl: 'app/login/templates/login.html',
                params: {
                    force: false,
                    fileId: "",
                    listId: "",
                },
                resolve: {
                    auth: function (loginService) {
                        return loginService.checkOauthEnabled();
                    }
                }
            })
            .state('oauth_logout', {
                url: '/oauth_logout',
                templateUrl: 'app/oauth/templates/oauth_logout.html',
                controller: 'oauth_logout',
                controllerAs: 'vm',
                params: {
                    force: false,
                }
            })
            .state('layout.results', {
                url: 'results',
                templateUrl: 'app/documentgrid/templates/results.html',
                sticky: true,
                dsr: true,
                params: {
                    force: false,
                }
            })
            .state('layout.testgrid', {
                url: 'testgrid',
                templateUrl: 'app/documentgrid/templates/testgrid.html',
                controllerAs: 'vm',
                controller: 'datagrid',
                sticky: true,
                dsr: true,
                params: {
                    force: false,
                }
            })
            .state('layout.results.grid', {
                url: '/grid',
                params: {
                    force: false,
                }
            })
            .state('layout.datacard', {
                url: 'datacard',
                templateUrl: 'app/datacard/templates/datacard.html',
                controller: 'dataCard',
                controllerAs: 'vm',
                params: {
                    force: false,
                }
            })
            .state('layout.searchcard', {
                url: 'searchcard',
                templateUrl: 'app/searchcard/templates/searchcard.html',
                params: {
                    force: false,
                }
            })
            .state('layout.tests', {
                url: 'tests',
                templateUrl: 'app/tests/templates/main.html',
                params: {
                    force: false,
                }
            })
            .state('layout.processing', {
                url: 'processing',
                templateUrl: 'app/common/templates/processing.html',
                params: {
                    force: false,
                }
            })
            .state('layout.logout', {
                url: 'logout',
                templateUrl: 'app/common/templates/processing.html',
                controller: 'logOut',
                controllerAs: 'vm',
                params: {
                    force: true,
                }
            })
            .state('viewpdf', {
                url: '/viewpdf/:fileInfo',
                templateUrl: 'app/viewpdf/templates/viewpdf.html',
                controller: 'viewPdf',
                controllerAs: 'vm',
                params: {
                    force: true,
                }
            })
            .state('viewer', {
                url: '/viewer/:fileInfo',
                templateUrl: 'app/viewpdf/templates/viewer.html',
                controller: 'viewer',
                controllerAs: 'vm',
                params: {
                    force: true,
                }
            })
            .state('layout.urlapi', {
                url: 'urlapi',
                controller: 'urlapi',
                templateUrl: 'app/urlapi/templates/urlapi.html',
                params: {
                    params: {}
                }
            })
    })
    .config(function ($httpProvider) {
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('preventTemplateCache');
    })

    .config(function (tmhDynamicLocaleProvider) {
        tmhDynamicLocaleProvider.localeLocationPattern('lib/angular-i18n/angular-locale_{{locale}}.js');
    })

    .config(function (errorHandlerProvider, $provide) {
        errorHandlerProvider.decorate($provide, [
            'loginService',
            'columnFactory',
            'searchService',
            'columnSetService',
            'gridDataService',
            'favoritesService',
            'savedSearchService',
            'sidebarservice',
            'selectionService',
            'dataCardService',
            'searchCardService',
            'lastSearchService',
            'SelectionCommand_WorkflowService',
            'ddService',
            'libraryService',
            'sendtoservice',
            'workAreaService',
            'zcs',
            'workAreaService',
            'folderBrowserService',
            'viewerService',
            'clientService',
            'extractionservice'
        ]);
    })

    .config(['$compileProvider', function ($compileProvider) {
        $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|file|blob):|data:image\//);
    }])

    .config(['$httpProvider', function ($httpProvider) {
        // Use x-www-form-urlencoded Content-Type
        $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
        $httpProvider.defaults.timeout = 999999;
        // Override $http service's default transformRequest
        $httpProvider.defaults.transformRequest = [function (data) {
            /**
             * The workhorse; converts an object to x-www-form-urlencoded serialization.
             * @param {Object} obj
             * @return {String}
             */
            var param = function (obj) {
                var query = '';
                var name, value, fullSubName, subName, subValue, innerObj, i;

                for (name in obj) {
                    value = obj[name];

                    if (value instanceof Array) {
                        for (i = 0; i < value.length; ++i) {
                            subValue = value[i];
                            fullSubName = name + '[' + i + ']';
                            innerObj = {};
                            innerObj[fullSubName] = subValue;
                            query += param(innerObj) + '&';
                        }
                    }
                    else if (value instanceof Object) {
                        for (subName in value) {
                            subValue = value[subName];
                            fullSubName = name + '[' + subName + ']';
                            innerObj = {};
                            innerObj[fullSubName] = subValue;
                            query += param(innerObj) + '&';
                        }
                    }
                    else if (value !== undefined && value !== null) {
                        query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
                    }
                }

                return query.length ? query.substr(0, query.length - 1) : query;
            };

            return angular.isObject(data) && String(data) !== '[object File]' ? param(data) : data;
        }];
    }])

    .run(function ($rootScope, errorHandler, $localStorage, $state, loginService, hubFactory, authService, $timeout, $cookies, systemOptionsService, $location, $mdDialog, sessionTimeoutService) {

        if ($location.search().code) {
            //alert($location.search().code);
            var decodedString = atob($location.search().code);
            loginService.refresh_token = decodedString;
            loginService.access_token = "temp";
            $localStorage.refreshToken = decodedString;
            $localStorage.ieRefreshToken = decodedString;
            $cookies.put("refreshToken", decodedString);
            
        };
        var viewerWindow;
        $rootScope.viewerWindow = viewerWindow;
        loginService.log(bowser);
        //error handler
        $rootScope.errorHandler = errorHandler;

        //get resource strings
        loginService.initStrings();
       
        // Get early for toolbar.
        systemOptionsService.getEnableUpload();
        systemOptionsService.getAllowDownload();
        systemOptionsService.getLocalViewerSettings();

        //auth handler
        $rootScope.$on('event:auth-loginRequired', function () {
            if (bowser.msie) loginService.refreshToken = $localStorage.ieRefreshToken;
            loginService.refreshToken().then(function (response) {
                loginService.log(new Date() + ' - Token refreshed successfully');
                //delay the refresh to allow time for the token to be written in local storage
                authService.loginConfirmed(response);
            }, function (response) {
                loginService.log(new Date() + ' - Token failed to refresh');
                loginService.failedRefresh = true;
                authService.loginCancelled("", response);
                $localStorage.refreshToken = "";
                $localStorage.token = "";
                loginService.clearData();
                $rootScope.loginHub.invoke('ResetConnection');
                $state.go("login");

            });
        });


        //set autologin based on what's in local storage
        loginService.autoLogin = $localStorage.userInfo ? $localStorage.userInfo.autoLogin : false;

        if (!$localStorage.userInfo) {
            $localStorage.userInfo = { id: '', userName: '', loginName: '', autoLogin: false, loggedIn: false };
            $localStorage.token = '';
            $localStorage.refreshToken = '';
            $cookies.userInfo = { id: '', userName: '', loginName: '', autoLogin: false, loggedIn: false };
            $cookies.token = '';
            $cookies.refreshToken = '';
        }

        if (!$localStorage.viewerOptions) {
            $localStorage.viewerOptions = { codebase: '', dms: '', jVueServer: '', Viewer3DFileExtensions: '' }
        }

        if (!$localStorage.userSettings) {
            $localStorage.userSettings = {};
        }

        

        //connection hub - set the user id
        $rootScope.loginHub = hubFactory('userConnectionHub', function () {
            //here some code can be added to do something after the connection is successful
            //console.log("Connected to signalr");
        });

        //subscribe to lock system for maintenance
        $rootScope.loginHub.on('onLockSystemForMaintenance', function (message) {
            loginService.logOut().then(function () {
                $state.go('login', { force: true }).then(function () {
                    $timeout(function () {
                        var msg = loginService.resourceStrings["LOGOUT_LOCKEDFORMAINT"];
                        msg += " " + message; //add administrator message to default lock message
                        var title = loginService.resourceStrings["LOGOUT"];
                        $rootScope.msgBoxShow(msg, title, 3);
                    }, 1000);
                });               
            });
        });

        //check if the user is logged in
        loginService.isLoggedIn().then(function (data) {
            console.log("Connecting Signal R user:", $localStorage.userInfo.id)
            //do not make a connection to signal r when viewing
            if (location.path().toLowerCase().indexOf('viewer') == -1 && location.path().toLowerCase().indexOf('viewpdf') == -1) {
                $rootScope.loginHub.start({
                    userId: $localStorage.userInfo.id,
                    clientId: "Adept",
                    autoLogin: $localStorage.userInfo.autoLogin,
                    loginName: $localStorage.userInfo.loginName,
                    userName: $localStorage.userInfo.userName
                });
            }

            //initialize the application
            loginService.initializeSession();

            sessionTimeoutService.onLoad(true);

        }, function (data) {
            loginService.checkOauthEnabled().then(function (answer) {
                if (!answer) {
                    $rootScope.loginHub.start({ clientId: "Adept" });
                }
            });          

            sessionTimeoutService.onLoad(false);
        });

        $rootScope.loginHub.on('logOut', function () {
            loginService.log("You were disconnected from your session because you logged in from another location");
        });

        var location = $location;
        //intercep router state change to check for token
        $rootScope.$on("$stateChangeStart", function (e, to, toParams, from, fromParams) {
            //alert("$stateChangeStart" + " to: " + to.name);
            if (to.name == "oauth_logout") {
                return;
            }


            //console.log("state change - to: " + to.name + " from: " + from.name);
            if (!toParams.force) {
                e.preventDefault();
                var goTo = to.name == "layout" ? "layout.home" : to.name;
                
                if (!angular.equals(location.search(), {})) {
                    $rootScope.routeParams = location.search();
                    if (to.name == "layout.urlapi" || to.name == "login") {
                        //alert(to.name);
                        loginService.goToState = "layout.urlapi";
                        if (to.name == "login") {
                            e.preventDefault();
                            goTo = "layout.urlapi";
                        }
                    }
                }

                loginService.isLoggedIn().then(function () {
                    //console.log("user is logged in");
                    if (to.name == "login" && goTo != "layout.urlapi") {
                        if (from.name != "") {
                            //console.log("from.name has a value");
                            return;
                        }
                        else {
                            //console.log("from.name does not have a value");
                            $state.go("layout.home", { force: true });
                            return;
                        }
                    }
                    toParams.force = true;
                    $state.go(goTo, toParams);
                }, function () {
                    $state.go("login", { force: true });
                });
            }
            else {
                if (!angular.equals(location.search(), {})) {
                    $rootScope.routeParams = location.search();
                    if (to.name == "layout.urlapi" || to.name == "login") {
                        loginService.goToState = "layout.urlapi";
                    }
                }
                else {
                    loginService.isLoggedIn();
                }
            }

            if (to.name == "layout") {
                e.preventDefault();
                $state.go("layout.home", { force: true });
            }
            return;
        });

    });


})();